import React, { lazy } from "react";
import Loadable from "../components/Loadable";
import { authRoles } from "../auth/authRoles";
import { routeCheck } from "app/data/roles";


const EquipmentReservation = Loadable(lazy(() => import("../views/reservation/EquipmentReservation")))

const reservationPaths = routeCheck(
    [ 
       { path: "/reservation/equipment", element: <EquipmentReservation/>, auth: authRoles.permitAll},
    ], 
    false 
)

export default reservationPaths